import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'
import StockOrderFrontList from '../entities/front-stockorder'
import createdata from '@/store/entities/create-stockorder'
import appconst from '@/lib/appconst';
import UserOrderStatistics from '@/store/entities/user-order-statistics';


interface FrontStockOrderState extends ListState<StockOrderFrontList> {
    orderInfo: createdata,

}

class FontStockOrderMutations extends ListMutations<StockOrderFrontList>{

}
class FontStockOrder extends ListModule<FrontStockOrderState, any, StockOrderFrontList>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<StockOrderFrontList>(),
        loading: false,
        orderInfo: new createdata(),
        orderStatus: null,
        packageStatus: null
    }
    actions = {
        async getAll(context: ActionContext<FrontStockOrderState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/FrontStockOrder/GetStockOrderList', { params: payload.data });
            context.state.loading = false;
            let page = reponse.data.result as PageResult<StockOrderFrontList>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
        async createOrder(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/FrontStockOrder/CreateStockOrder', payload.data);
        },
        async urgentOrder(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/FrontStockOrder/urgentOrder?id=' + payload.data.stockOrderId);
        },
        async updateOrder(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/FrontStockOrder/UpdateOrder', payload.data);
        },
        async CancleStockOrder(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/FrontStockOrder/CancleStockOrder?stockOrderId=' + payload.data.stockOrderId);
        },
        async normalOrder(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/FrontStockOrder/NormalOrder?stockOrderId=' + payload.data.stockOrderId);
        },
        async getOrder(context: ActionContext<FrontStockOrderState, any>, payload: any) {
            let reponse = await Ajax.get('/api/services/app/FrontStockOrder/GetStockOrderInfo?stockOrderId=' + payload.data.stockOrderId );
            context.state.orderInfo = (reponse.data.result as createdata);
        },
        async getOrderStatistics(state: any, payload: any) {
            let rep = await Ajax.get('/api/services/app/FrontStockOrder/GetOrderStatistics', payload.data);
            return rep.data.result as UserOrderStatistics;
        },
       

    };
    mutations = {
        setCurrentPage(state: FrontStockOrderState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: FrontStockOrderState, pagesize: number) {
            state.pageSize = pagesize;
        },
        getPdf(state: FrontStockOrderState, data: any) {
            if (data.pdfGuid && data.pdfGuid.length > 1) {
                window.open(appconst.remoteServiceBaseUrl + "api/File/GetPdf?guid=" + data.pdfGuid + "&id=" + (data.userId ? data.userId : abp.session.userId) + "&orderNumber=" + data.orderNumber);
            }
        }
    }
}

const frontstockorders = new FontStockOrder();
export default frontstockorders;